import { UserBusinessInformationAdminModel, UserLocalInfoResponseModel } from "@payping/api";
import { atom } from "jotai";

interface SettingsBusinessAtom {
  mobileFormEdit: UserBusinessInformationAdminModel &
    UserLocalInfoResponseModel & { citiesList?: { cityName: string; cityId: number }[] };
}
export const settingsBusinessAtom = atom<SettingsBusinessAtom>({
  mobileFormEdit: {
    businessName: undefined,
    businessDescription: undefined,
    state: undefined,
    city: undefined,
    postalCode: undefined,
    address: undefined,
    localPhone: undefined,
    taxCode: undefined,
    site: undefined,
    companyName: undefined,
    sabtNumber: undefined,
    registrationDate: undefined,
    bNationalCode: undefined,
    economicCode: undefined,
    documents: undefined,
  },
});
